import { render, staticRenderFns } from "./ProjectSummaryProgress.vue?vue&type=template&id=bb434b78"
import script from "./ProjectSummaryProgress.vue?vue&type=script&lang=js"
export * from "./ProjectSummaryProgress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports